import { makeAutoObservable } from "mobx";
import type { UserInfoResponse } from "@/types/api";

export class UserStore {
  userInfo: UserInfoResponse | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setUserInfo(userInfo: UserInfoResponse | null) {
    this.userInfo = userInfo;
  }

  clearUserInfo() {
    this.userInfo = null;
  }
}
